import React from 'react';
import Typography from "@mui/material/Typography";
import {Trans} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import {Delete} from "@mui/icons-material";

function AdminFileParam({param, onChange, onDelete}) {
    return (
        <div>
            <Typography fontWeight={500} sx={{pb: 2}}>
                {param.key}
                <IconButton onClick={onDelete}><Delete/></IconButton>
            </Typography>
            <Typography>
                <Trans i18nKey={`params.${param.key}`}/>
            </Typography>
        </div>
    );
}

export default AdminFileParam;
